import {
    ModalBody,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    ModalContent,
    ModalCloseButton,
    Divider,
    Button,
    Input,
    Text,
    Box,
    HStack,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Image,
} from '@chakra-ui/react';
import { useState, useRef } from 'react';
import { IconButton } from '@mui/material';   
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import { IconButton } from '@fortawesome/react-fontawesome';
// import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
// import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import CancelIcon from '@mui/icons-material/Cancel';
import FileIcon from '../../components/FileIcon';
import { useDropzone } from 'react-dropzone';
import React from 'react';
import apiClient from '../../clients/apiClient.js';
import { useEffect } from 'react';
const WeblinkModal = ({ setIsLibraryOpen }) => {
    const [weblink, setWeblink] = useState('');
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');

    const addWeblink = () => {
      let addWeblink = {
        link_url: weblink,
        name: name,
        description: description,
      }

      apiClient.post('/library/weblinks', { 
        action: "add_new_link",
        add_new_link: addWeblink,
       }).then(
        ({data}) => {
          setWeblink('');
          setName('');
          setDescription('');
        }
      )
    }

    const handleAddWeblink = () => {
      setWeblink('');
      setName('');
      setDescription('');
      addWeblink();
      setIsLibraryOpen();
    };

    const adjustTextareaHeight = (textarea) => {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    };

    useEffect(() => {
      const textareas = document.querySelectorAll('textarea');
      textareas.forEach((textarea) => {
        adjustTextareaHeight(textarea);
        textarea.addEventListener('input', () => adjustTextareaHeight(textarea));
      });

      return () => {
        textareas.forEach((textarea) => {
          textarea.removeEventListener('input', () => adjustTextareaHeight(textarea));
        });
      };
    }, []);

    return (
      <Box display="flex" alignItems="center" justifyContent="center" height="100vh">
        <ModalOverlay />
        <ModalContent w={'fill'} minWidth="32%" maxWidth="84%" margin="auto" alignSelf="flex-start">
          <ModalCloseButton />
          <ModalHeader>Weblinks</ModalHeader>
          <Divider />
        
          <ModalBody>
            <Text mb={4}>Add Weblink to your library</Text>
            <Box mb={4}>
              <HStack spacing={4}>
                <Input
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  as="textarea"
                  resize="none"
                  height="auto"
                  alignContent={"center"}
                />
                <Input
                  placeholder="Weblink"
                  value={weblink}
                  onChange={(e) => setWeblink(e.target.value)}
                  as="textarea"
                  resize="none"
                  height="auto"
                  alignContent={"center"}
                />
                <Input
                  placeholder="Description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  as="textarea"
                  resize="none"
                  height="auto"
                  alignContent={"center"}
                />
                <Button
                  onClick={handleAddWeblink}
                  colorScheme="blue"
                  variant="outline"
                  color="#2584FD"
                  paddingX={8}
                >
                  Add
                </Button>
              </HStack>
            </Box>
          </ModalBody>
        </ModalContent>
      </Box>
    );
  };
  
  export default WeblinkModal;
  